var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33366 9.37456V13.3333H8.66699V9.37456C11.2979 9.70263 13.3337 11.9469 13.3337 14.6666H2.66699C2.66699 11.9469 4.70279 9.70263 7.33366 9.37456ZM8.00033 8.66663C5.79033 8.66663 4.00033 6.87663 4.00033 4.66663C4.00033 2.45663 5.79033 0.666626 8.00033 0.666626C10.2103 0.666626 12.0003 2.45663 12.0003 4.66663C12.0003 6.87663 10.2103 8.66663 8.00033 8.66663Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserWhite);
export default __webpack_public_path__ + "static/media/user-white.6b370bdf4e6a0b7dfb115db2c40ea530.svg";
export { ForwardRef as ReactComponent };